export default __webpack_public_path__ + "static/cdn-b406a7141ff8f4345626477bcfd985b4.png";